import React from 'react'
// import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
// import useMediaQuery from '@mui/material/useMediaQuery'
import Grid from '@mui/material/Grid'
import Main from '../MainLayouts/Main'
import Container from '../GeneralComponents/Container'

const TermsConditions = () => {
  // const theme = useTheme()
  // const isMd = useMediaQuery(theme.breakpoints.up('md'), {
  //   defaultMatches: true,
  // })

  return (
    <Main>
      <Box
        position={'relative'}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'flex-start'}
        height={1}
        marginTop={-12}
        paddingTop={12}
      >
        <Container>
          <Grid container>
            <Grid
              item
              container
              alignItems={'center'}
              justifyContent={'flex-start'}
              xs={12}
              md={12}
            />
            <Box>
              <h1>Terms and Conditions</h1>
              <p>
                <br />
                Welcome to Drivolo.com. These Terms and Conditions outline the
                rules and regulations governing your use of the Drivolo website
                (&quot;the Website&quot;), accessible at www.Drivolo.com.
                <br />
                <br />
                By accessing this Website, you agree to comply fully with these
                Terms and Conditions. If you do not agree with any part of these
                Terms and Conditions, you must not continue to use Drivolo.com.
              </p>
              <h2>1. Definitions</h2>
              <ul>
                <li><strong>&quot;User,&quot; &quot;you,&quot; &quot;your&quot;</strong> refers to the person accessing or using this Website.</li>
                <li><strong>&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot; &quot;our&quot;</strong> refers to Drivolo.</li>
                <li><strong>&quot;Service&quot;</strong> refers to any services provided by Drivolo through the Website.</li>
              </ul>
              <h2>2. Acceptance of Terms</h2>
              <p>
                By using the Website, you represent and warrant that you have
                read, understood, and agree to be bound by these Terms and
                Conditions and our Privacy Policy.
              </p>
              <h2>3. User Obligations</h2>
              <p>You agree to:</p>
              <ul>
                <li>Provide accurate, current, and complete information.</li>
                <li>Maintain and update your account information promptly.</li>
                <li>Ensure the confidentiality of your login credentials and notify Drivolo immediately of any unauthorized use.</li>
              </ul>
              <h2>4. Intellectual Property Rights</h2>
              <p>
                All content on Drivolo.com, including text, graphics, logos,
                images, software, and any other materials, are the exclusive
                property of Drivolo or its licensors and are protected by
                copyright and trademark laws. You may not reproduce, modify,
                distribute, or use any materials without prior written
                permission from Drivolo.
              </p>
              <h2>5. Prohibited Activities</h2>
              <p>You must not:</p>
              <ul>
                <li>Use the Website for any unlawful purposes.</li>
                <li>Engage in activities that could harm, disable, or impair the Website&apos;s functionality.</li>
                <li>Attempt to gain unauthorized access to Drivolo&apos;s systems.</li>
                <li>Post or transmit harmful, abusive, obscene, or offensive content.</li>
              </ul>
              <h2>6. Limitation of Liability</h2>
              <p>
                Drivolo, its directors, employees, or affiliates will not be
                liable for any indirect, incidental, consequential, or punitive
                damages arising from your use or inability to use the Website.
              </p>
              <h2>7. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Drivolo, its
                affiliates, directors, and employees from any claims, losses,
                liabilities, damages, or expenses (including reasonable legal
                fees) arising from your violation of these Terms and Conditions.
              </p>
              <h2>8. Disclaimer of Warranties</h2>
              <p>
                The Website and its content are provided &quot;as is&quot;
                without any warranties, expressed or implied. Drivolo does not
                guarantee that the Website will always be accessible,
                uninterrupted, or error-free.
              </p>
              <h2>9. Third-Party Links</h2>
              <p>
                Drivolo.com may contain links to third-party websites or
                services. Drivolo has no control over and assumes no
                responsibility for the content, privacy policies, or practices
                of any third-party websites.
              </p>
              <h2>10. Changes to Terms</h2>
              <p>
                Drivolo reserves the right to update or modify these Terms and
                Conditions at any time without prior notice. Your continued use
                of the Website after changes constitutes your acceptance of the
                revised Terms.
              </p>
              <h2>11. Termination</h2>
              <p>
                Drivolo reserves the right, at its sole discretion, to terminate
                or suspend your access to the Website without prior notice for
                violations of these Terms and Conditions.
              </p>

              <h2>13. Contact Information</h2>
              <p>If you have questions, contact us at Support@drivolo.com.</p>
              <div className="contact-info">
                <p>Drivolo</p>
                <p>
                  <a href="tel:+918143869980">+91 8143869980</a>
                </p>
              </div>
              <div className="footer">
                <p>
                  <a href="mailto:Support@drivolo.com">Support@drivolo.com</a>
                </p>
              </div>
            </Box>
          </Grid>
        </Container>
      </Box>
    </Main>
  )
}

export default TermsConditions
